import { Box, VStack, Text, Input, Button, HStack } from '@chakra-ui/react';
import React, { useState } from 'react';

import {
  error as commonError,
  utils as commonUtils,
} from '@finley-technologies/common';

// quick test to convert a text into base64 encoded and back
export const Base64ConversionUtil = () => {
  const [base64, setBase64] = useState<string>('');
  const [encoded, setEncoded] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleEncode = () => {
    try {
      setEncoded(commonUtils.base64Encode(base64));
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(commonError.getErrorMessage(error));
    }
  };

  const handleDecode = () => {
    try {
      setBase64(commonUtils.base64Decode(encoded));
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(commonError.getErrorMessage(error));
    }
  };

  return (
    <Box mt={4} border="1px solid" padding={2}>
      <Text>Test Base64 Conversion</Text>
      <HStack mt={4} spacing={4} align="center">
        {/* Decoded Input */}
        <VStack align="start">
          <Text>Decoded Text:</Text>
          <Input
            value={base64}
            onChange={(e) => {
              setBase64(e.target.value);
              setEncoded(''); // Clear encoded field when base64 input changes
            }}
            placeholder="Enter text to encode"
          />
        </VStack>

        {/* Buttons */}
        <VStack>
          <Button onClick={handleEncode}>Encode &gt;&gt;</Button>
          <Button onClick={handleDecode}>&lt;&lt; Decode</Button>
        </VStack>

        {/* Encoded Input */}
        <VStack align="start">
          <Text>Base64 Encoded String:</Text>
          <Input
            value={encoded}
            onChange={(e) => {
              setEncoded(e.target.value);
              setBase64(''); // Clear base64 field when encoded input changes
            }}
            placeholder="Enter base64 encoded string"
          />
        </VStack>
      </HStack>

      {errorMessage && <Text color="red">{errorMessage}</Text>}
    </Box>
  );
};
